import { dollarTemplate, formatCanvasPrintDetails, getLineItemThumbnailUrl, getLineItemPhotoLabel, getFinishTypeLabel, splitMultiOpeningPrintSizeName, isMultiOpeningPrintSizeName } from "../../../../lib/utils";
import { ReactComponent as DownloadIcon } from "../../../../images/icons/dowload-alternative.svg";
import { ReactComponent as AttachmentIcon } from "../../../../images/icons/attachment.svg";
import { useEffect, useState } from "react";
import downloadinGIF from "../../../../animations/downloading.gif";
import { getPaperType, getLineItemServiceType } from "../../../../lib/const";
import LineItemNotes from "./LineItemNotes";
import { useLabOrderDetailsStore } from '../../../../stores'
import { MultiOpeningMatSummaryThumbnail } from "./MultiOpeningLineItemSummary";
import LineItemPhotoModal from "../../../ProductSelection/LineItemPhotoModal";
import MultiOpeningPhotoModal from "../../../ProductSelection/MultiOpeningPhotoModal";

const LineItem = ({ lineItem }) => {
  const { isAdmin, globalSelect, setGlobalSelect, selectedItems, setSelectedItems, filteredLineItems, filteredMultiOpeningLineItems, updateLineItemStatus, updateLineItem, labOrderId, downloadLineItemZip } = useLabOrderDetailsStore();

  const [loading, setLoading] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false);
  const [localSelect, setLocalSelect] = useState(false)
  const [localStatus, setLocalStatus] = useState(lineItem?.status || "printing")
  const [disableLineItem, setDisableLineItem] = useState(false)
  const [photoModalOpen, setPhotoModalOpen] = useState(false)

  useEffect(() => {
    const disableIem = selectedItems.includes(lineItem?.guid)
    setDisableLineItem(disableIem)
  }, [selectedItems, lineItem?.guid])

  useEffect(() => {
    setLocalStatus(lineItem?.status ?? "open");
  }, [lineItem?.status]);

  useEffect(() => {
    setLocalSelect(globalSelect)
  }, [globalSelect])

  const downloadLineItem = async () => {
    try {
      setIsDownloading(true);
      await downloadLineItemZip(lineItem?.guid, lineItem?.isMultiOpening);
    } catch (err) {
      console.error("Download error", err);
    } finally {
      setIsDownloading(false);
    }
  };

  const lineItemStatus = async (e) => {
    setLocalStatus(e.target.value)
    try {
      if (selectedItems.length > 0 && updateLineItemStatus && labOrderId) {
        await updateLineItemStatus(e, selectedItems, labOrderId)
      } else if (updateLineItem && labOrderId) {
        const newStatus = e.target.value;
        await updateLineItem("status", newStatus, labOrderId, lineItem?.guid);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const updateNotes = async (type, value) => {
    if (!updateLineItem || !labOrderId) return;
    setLoading(true);
    try {
      await updateLineItem(type, value, labOrderId, lineItem?.guid)
    } catch (error) {
      console.log('error updating line item notes...')
    } finally {
      setLoading(false)
    }
  }

  const usedPaper = lineItem?.photographType !== 'test-prints' && getPaperType(lineItem?.paperName || lineItem?.printSizeAttributes?.paper);

  const editingSoftwareName =
    lineItem?.editingSoftware?.attributes?.name ||
    lineItem?.editingSoftware?.name ||
    lineItem?.editingSoftwareOption?.attributes?.name ||
    lineItem?.editingSoftwareOption?.name ||
    lineItem?.editingSoftwareName ||
    (typeof lineItem?.editingSoftware === 'string' ? lineItem.editingSoftware : '');

  const isMultiOpeningProduct = lineItem?.isMultiOpening || isMultiOpeningPrintSizeName(lineItem?.printSizeAttributes?.printSize);

  const usedService = getLineItemServiceType(lineItem, isMultiOpeningProduct);

  const multiOpeningNameParts = isMultiOpeningProduct
    ? splitMultiOpeningPrintSizeName(lineItem?.printSizeName)
    : null;

  const multiOpeningFinishType = isMultiOpeningProduct
    ? (() => {
        const label = getFinishTypeLabel(lineItem);
        return label && label !== "none" ? label : multiOpeningNameParts?.finishType;
      })()
    : null;

  const multiOpeningPrintDetails = [
    lineItem?.printSizeAttributes?.paper || lineItem?.paperName,
    lineItem?.printSizeAttributes?.printSize || multiOpeningNameParts?.size,
  ]
    .filter(Boolean)
    .join(" ");

  let details = [
    lineItem?.finishingService?.formattedDetailOne,
    lineItem?.finishingService?.formattedDetailTwo,
    lineItem?.finishingService?.formattedDetailThree,
  ];
  if (isMultiOpeningProduct && !details.some(Boolean)) details = [multiOpeningNameParts?.size];
  if (!isMultiOpeningProduct && editingSoftwareName) details = [editingSoftwareName];
  const lineItemDetails = details.filter(Boolean);

  const handleLocalSelect = () => {
    if (localSelect) {
      let newItems = [...selectedItems];
      newItems = newItems.filter((item) => item != lineItem.guid);
      if (newItems.length == 0) {
        setGlobalSelect(false)
      }
      setSelectedItems(newItems)
    } else {
      const newItems = [...selectedItems];
      newItems.push(lineItem?.guid)
      if (filteredLineItems.length + filteredMultiOpeningLineItems.length == newItems.length) {
        setGlobalSelect(true)
      }
      setSelectedItems(newItems)
    }
    setLocalSelect(!localSelect)
  }

  return (
    <>
      <div
        className={`w-layout-grid  ${isAdmin ? "grid-element-order-summary unbundled-list" : " grid-element-order-summary client less "}`}
        style={{
          gridTemplateColumns: isAdmin
            ? '35px 60px 100px 140px 110px 160px 230px 35px 65px 100px 50px'
            : '80px 180px 110px 140px 160px 55px 65px',
        }}
      >

        {/* Checkbox */}
        {isAdmin && <div className="content order-summary-checkbox-cell">
          <div className="form-block-7 w-form" onClick={handleLocalSelect}>
            <label className="w-checkbox">
              <div className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox-7 ${(globalSelect && localSelect) || localSelect ? "w--redirected-checked" : ""}`}></div>
            </label>
          </div>
        </div>}

        {isAdmin && <div className="content">
          <div className="w-layout-grid grid-90">
            {usedService && (
              <div className={`dot bigger ${usedService.iconClassname}`}>
                <div>{usedService.abbreviation}</div>
              </div>
            )}
            {usedPaper && (
              <div className="dot bigger paper">
                <div>{usedPaper.abbreviation}</div>
              </div>
            )}
          </div>
        </div>}

        <div className="content">
          <div className="div-block-136" style={{ width: '100%' }}>
            {isMultiOpeningProduct ? (
              <div
                className="w-inline-block w-lightbox"
                style={{ display: 'block', width: '100%', cursor: 'pointer' }}
                onClick={() => setPhotoModalOpen(true)}
              >
                <MultiOpeningMatSummaryThumbnail lineItem={lineItem} className="img-order-summary" />
              </div>
            ) : (
              <div
                className="w-inline-block w-lightbox"
                style={{ display: 'block', width: '100%', cursor: 'pointer' }}
                onClick={() => setPhotoModalOpen(true)}
              >
                <img
                  src={getLineItemThumbnailUrl(lineItem)}
                  alt={getLineItemPhotoLabel(lineItem) || "Preview"}
                  className="img-order-summary"
                  loading="lazy"
                  style={{ objectFit: "contain", border: '1px solid #e0dede' }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="content print-details unbundled-list">
          <div className="div-block-350">
            <div>
              {isMultiOpeningProduct
                ? multiOpeningPrintDetails
                : getFinishTypeLabel(lineItem) === "TEST PRINTS"
                  ? "TEST PRINTS"
                : (() => {
                    const paper = lineItem?.printSizeAttributes?.paper || "";
                    const printSize = lineItem?.printSizeAttributes?.printSize || "";

                    // Only format if it's canvas, otherwise use original format
                    if (paper.toLowerCase().startsWith("canvas")) {
                      return formatCanvasPrintDetails(paper, printSize);
                    }

                    // Original format for non-canvas items (no function call needed)
                    return `${paper} ${printSize}`;
                  })()}
            </div>
            <div className="w-layout-grid grid-23 main align-left">
              <div className="icon smaller w-embed">
                <AttachmentIcon />
              </div>
              <div>{getLineItemPhotoLabel(lineItem)}</div>
            </div>
          </div>
        </div>

        <div className={isAdmin ? 'content' : 'content center'} style={{ textAlign: isAdmin ? 'left' : 'center' }}>
          <div className="text-table _12px semi-bold">
            {isMultiOpeningProduct ? multiOpeningFinishType : getFinishTypeLabel(lineItem)}
          </div>
        </div>

        <div className="content">
          <div className="text-table-top-container">
            {(lineItemDetails.length ? lineItemDetails : ['none']).map((detail, idx) => (
              <div key={idx} className="text-table _12px semi-bold">
                {detail}
              </div>
            ))}
          </div>
        </div>

        {isAdmin ?
          <LineItemNotes lineItem={lineItem} updateLineItem={updateNotes} loading={loading} setLoading={setLoading} />
          : <div className="content text-table smaller red">{lineItem?.notes}</div>}

        <div className="content" style={{ textAlign: isAdmin ? 'left' : 'center', alignItems: isAdmin ? 'flex-start' : 'center' }}>
          <div className={`text-table ${lineItem?.quantity > 1 ? "red" : ""}`}>
            {lineItem?.quantity}
          </div>
        </div>

        <div className="content">
          <div className="text-table price">
            {dollarTemplate(lineItem?.itemTotal)}
          </div>
        </div>

        {isAdmin && <div id="w-node-_53dbd4f7-0b25-2698-a0dd-5e49a732f095-6be80a0f" className="content">
          <div className="form-block-input w-form">
            <form id="email-form" name="email-form" data-name="Email Form" className="form-input select-field">
              <div
                className="select-field-wrapper"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: 0,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  const select = e.currentTarget.querySelector("select");
                  if (select) select.focus();
                }}
              >
                <select
                  id="save"
                  name="field-3"
                  className="form-select-field w-select"
                  value={localStatus}
                  onChange={(e) => lineItemStatus(e)}
                  style={{
                    minWidth: "105px",
                    padding: "0px",
                    paddingLeft: "5px",
                    cursor: disableLineItem ? "not-allowed" : "pointer",
                  }}
                  disabled={disableLineItem ? true : false}
                >
                  <option value="open">Open</option>
                  <option value="paid">Paid</option>
                  <option value="printing">Printing</option>
                  <option value="matting">Matting</option>
                  <option value="mounting">Mounting</option>
                  <option value="framing">Framing</option>
                  <option value="canvas_production">Canvas Prod</option>
                  <option value="album_production">Album Prod</option>
                  <option value="reprint">Reprint</option>
                  <option value="ready_to_ship">Ready To Ship</option>
                  <option value="shipped">Shipped</option>
                  <option value="on_hold">On Hold</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </form>
          </div>
        </div>}

        {isAdmin && <div className="content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }} onClick={downloadLineItem}>
          <div className="link-block-14 w-inline-block">
            <div className={!isDownloading ? "icon w-embed" : ""}>
              {isDownloading ? (
                <img
                  src={downloadinGIF}
                  alt="Downloading..."
                  width="40"
                  height="40"
                />
              ) : (
                <DownloadIcon />
              )}
            </div>
          </div>
        </div>}
      </div>
      <hr style={{ border: 0, borderTop: "1px solid #e0dede", width: "98%" }} />

      {isMultiOpeningProduct ? (
        <MultiOpeningPhotoModal
          isOpen={photoModalOpen}
          onClose={() => setPhotoModalOpen(false)}
          lineItem={lineItem}
        />
      ) : (
        <LineItemPhotoModal
          isOpen={photoModalOpen}
          onClose={() => setPhotoModalOpen(false)}
          lineItem={lineItem}
        />
      )}
    </>

  );
};

export default LineItem;
